import templateUrl from './employers-directory-view.html';

import "./employers-directory-view.scss"

export const EmployersDirectoryViewComponent = {
    templateUrl,
    bindings: {
        details: "<",
    },
    controller: class EmployersDirectoryListComponent {
        constructor($state, toastr, ApiService, EmployersDirectoryService) {
            "ngInject";
            this.$state = $state;
            this.toastr = toastr;
            this.ApiService = ApiService
            this.EmployersDirectoryService = EmployersDirectoryService;
          }

        $onInit() {
          this.imageUrl = '/./images/cover-pic.jpg';
          this.staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${this.details.companyAddress.addressLine1}+CA${this.details.companyAddress.stateCode}&zoom=8&scale=2&size=200x150&maptype=roadmap&format=png&key=AIzaSyDm02nDtGVhg-5Dnovkduz5XGT5LJgFmI4`;

          if(this.details && this.details.fileUuid) {
            this.imageUrl = this.ApiService.getImageUrl(this.details.fileUuid);
          }
          
        }
        
        handleEditClick() {
           this.$state.go("employersDirectoryEdit",{
             group_id: this.details.companyDirectoryId
           })
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory-view/employers-directory-view.component.js